import { InjectionToken } from '@angular/core';

export const PROGRAM_YEAR = new InjectionToken<number>(`program-year`);
